import React from 'react';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import { assign } from 'xstate';
import { cloneDeep } from 'lodash';
import { IntlShape } from 'react-intl';

import { MachineContext } from '../../MachineContext';
import { BaseComponent } from '../Component';
import { translateWithFallback } from '../../util';

import styles from './Audio.module.css';
import { AudioEnum } from './AudioEnum';

export interface AudioDisplayComponent extends BaseComponent {
  type: 'audioDisplay';
  props: AudioDisplayProps;
}

export interface AudioDisplayProps {
  src: string;
  audioText: string;
  audioImage: AudioEnum;
  assetid: string;
  resolvedsrc: string;
}

export const AudioDisplay: React.FC<AudioDisplayProps> = ({
  src,
  audioText,
  audioImage,
  assetid,
  resolvedsrc,
}) => {
  return (
    <Card
      sx={{
        minWidth: '350px',
        boxShadow: 'none',
      }}
    >
      <CardContent>
        <Typography align="center" gutterBottom variant="h5" component="h2">
          {audioText}
        </Typography>
        {audioImage !== AudioEnum.NONE && (
          <div className={`${styles['audio-image']} ${styles[audioImage]}`} />
        )}
      </CardContent>
      <CardContent>
        <CardMedia
          key={assetid ?? src}
          component="audio"
          controls
          /*height="152"*/
          image={resolvedsrc}
        />
      </CardContent>
    </Card>
  );
};

export const renderAudioDisplayAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const payload = actionMetadata.action.payload;

    newContext.widgetData.push({
      type: 'audioDisplay',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        src: payload.src,
        resolvedsrc: payload.resolvedsrc,
        assetid: payload.assetid,
        audioText: translateWithFallback(intl, payload.audioText),
        audioImage: payload.audioImage,
      },
    });
    return newContext;
  });
};
